import { ReactNode } from "react";
import { cn } from "lib/utils";

type Tone = "default" | "danger" | "success";

const TONE_VALUE_CLASS: Record<Tone, string> = {
  default: "text-slate-900",
  danger: "text-red-600",
  success: "text-green-600",
};

type Props = {
  label: string;
  value: ReactNode;
  icon?: ReactNode;
  tone?: Tone;
  className?: string;
};

const AdminStatCard = ({ label, value, icon, tone = "default", className }: Props) => (
  <div
    className={cn(
      "bg-white rounded-xl border border-slate-200/80 shadow-[0_1px_2px_rgba(15,23,42,0.04)] px-5 py-4 flex flex-col gap-2",
      className
    )}
  >
    <div className="flex items-center justify-between">
      <p className="text-[11px] font-semibold tracking-wide text-slate-500 uppercase">{label}</p>
      {icon && <span className="text-slate-300 [&>svg]:w-4 [&>svg]:h-4">{icon}</span>}
    </div>
    <p className={cn("text-[28px] leading-none font-semibold tabular-nums", TONE_VALUE_CLASS[tone])}>{value}</p>
  </div>
);

export default AdminStatCard;
